import Block from 'components/Block'
import ContentBox from 'components/ContentBox'
import TextBody from 'components/TextBody'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextTitleCompressedHeavyUpperCase from 'components/TextTitleCompressedHeavyUpperCase'
import TextTitleCompressedLight from 'components/TextTitleCompressedLight'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_FONT_SIZE } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { useTheme } from 'modules/styles/index.js'

const messages = defineMessages({
  title: {
    id: 'AppHowItWorks.title',
    defaultMessage: 'How It Works'
  },
  stepIndex: {
    id: 'AppHowItWorks.stepIndex',
    defaultMessage: 'Step {index}'
  },

  // Step 1: Goals
  setYourGoals: {
    id: 'AppHowItWorks.setYourGoals',
    defaultMessage: 'Set Your Goals'
  },
  setYourGoalsDescription: {
    id: 'AppHowItWorks.setYourGoalsDescription',
    defaultMessage:
      'Choose fat loss, muscle gain, or healthier habits and we will personalize your plan.'
  },

  // Step 2: Workouts + Nutrition
  workoutsAndNutrition: {
    id: 'AppHowItWorks.workoutsAndNutrition',
    defaultMessage: 'Workouts & Nutrition in One App'
  },
  workoutsAndNutritionDescription: {
    id: 'AppHowItWorks.workoutsAndNutritionDescription',
    defaultMessage:
      'Follow guided workout plans and log meals in seconds using photo, voice, or text.'
  },

  // Step 3: Progress
  trackYourProgress: {
    id: 'AppHowItWorks.trackYourProgress',
    defaultMessage: 'Track Your Progress'
  },
  trackYourProgressDescription: {
    id: 'AppHowItWorks.trackYourProgressDescription',
    defaultMessage:
      'See changes in your body, strength, and nutrition all in one place.'
  }
})

const STEPS = [
  {
    titleMessage: messages.setYourGoals,
    descriptionMessage: messages.setYourGoalsDescription
  },
  {
    titleMessage: messages.workoutsAndNutrition,
    descriptionMessage: messages.workoutsAndNutritionDescription
  },
  {
    titleMessage: messages.trackYourProgress,
    descriptionMessage: messages.trackYourProgressDescription
  }
]

export function AppHowItWorks () {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const intl = useIntl()
  const theme = useTheme()

  return (
    <Block
      bgc='black'
      style={{
        color: 'white',
        textAlign: 'center'
      }}
    >
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View mb={4}>
          <TextTitleCompressedHeavy>
            {formatMessageIntlUtil(intl, messages.title)}
          </TextTitleCompressedHeavy>
        </View>

        <View
          row={!isSmallScreen}
          centered
        >
          {STEPS.map((step, index) => {
            const {
              titleMessage,
              descriptionMessage
            } = step
            return (
              <ContentBox
                key={index}
                f
                mt={isSmallScreen}
                bgc={null}
              >
                <TextTitleCompressedLight style={{ color: 'white' }}>
                  {formatMessageIntlUtil(intl, messages.stepIndex, { index: index + 1 })}
                </TextTitleCompressedLight>

                <TextTitleCompressedHeavyUpperCase
                  mt
                  style={{ fontSize: STYLES_FONT_SIZE.HEADING_SMALL }}
                >
                  {formatMessageIntlUtil(intl, titleMessage)}
                </TextTitleCompressedHeavyUpperCase>

                <View mt>
                  <TextBody mt>
                    {formatMessageIntlUtil(intl, descriptionMessage)}
                  </TextBody>
                </View>
              </ContentBox>
            )
          })}
        </View>
      </View>
    </Block>
  )
}
